<template>
	<div class="wise-planner" id="plan-a-payment">
		<div class="planner-top"><PdEyebrow>Payment preview</PdEyebrow><PdEyebrow tone="muted">01 / 03</PdEyebrow></div>
		<h3>What are you paying for?</h3>
		<PdField label="Choose a payment" for="payment-category">
			<PdSelect id="payment-category" :model-value="category" :options="categoryNames" @update:model-value="emit('update:category', $event)" />
		</PdField>
		<PdField label="Amount to pay" for="payment-amount">
			<PdAmountInput id="payment-amount" v-model="amount" size="md" :min="1" :max="999999999" aria-describedby="planner-note" />
		</PdField>
		<div class="planner-summary" aria-live="polite">
			<span>Your payment</span>
			<strong>{{ category }}</strong>
			<b class="pd-num">{{ amount > 0 ? formatINR(amount, { whole: true }) : "Enter an amount" }}</b>
		</div>
		<PdButton v-if="amount > 0" block spread size="lg" :href="registerUrl" :icon-right="ArrowRight">Continue</PdButton>
		<PdButton v-else block spread size="lg" disabled :icon-right="ArrowRight">Continue</PdButton>
		<p id="planner-note" class="planner-note"><Lock :size="14" aria-hidden="true" />Preview only. Eligibility, recipient details and any charges are shown before a real payment is confirmed.</p>
	</div>
</template>

<script setup>
import { ref } from "vue";
import { ArrowRight, Lock } from "lucide-vue-next";
import PdEyebrow from "@paydeck-ui/components/PdEyebrow.vue";
import PdField from "@paydeck-ui/components/PdField.vue";
import PdSelect from "@paydeck-ui/components/PdSelect.vue";
import PdAmountInput from "@paydeck-ui/components/PdAmountInput.vue";
import PdButton from "@paydeck-ui/components/PdButton.vue";
import { formatINR } from "@paydeck-ui/data/format.js";
import { categories } from "@/content/home";
import { registerUrl } from "@/content/site";

defineProps({ category: { type: String, required: true } });
const emit = defineEmits(["update:category"]);

const categoryNames = categories.map((item) => item.name);
const amount = ref(25000);
</script>
